import { jsx as _jsx } from "react/jsx-runtime";
import { WaterHint } from './water';
import { AirHint } from './air';
import { MessageBox } from 'shared/components/dialogs/message-box';
import { ErrorBoundary } from 'shared/components/error-boundary';
import { ConnectWiresHint } from 'console/entities/settings-master/ui/hints/connect-wires';
import { AirZota } from 'entities/settings-master/ui/hints/airZota';
import { OutsideTemperature } from 'entities/settings-master/ui/hints/outside-temperature';
import { PopupError } from 'entities/settings-master/ui/hints/popup-error';
const hint_dialog_content = new Map([
    ['water_smart_new', _jsx(WaterHint, { device_type: "SMART" })],
    ['water_h1_new', _jsx(WaterHint, { device_type: "H1V" })],
    ['air_smart_new', _jsx(AirHint, { device_type: "SMART" })],
    ['air_h1_new', _jsx(AirHint, { device_type: "H1V" })],
    ['connect-wires', _jsx(ConnectWiresHint, {})],
    [
        'noDhw',
        _jsx(PopupError, { text: "\u0414\u0430\u0442\u0447\u0438\u043A \u0413\u0412\u0421 \u043D\u0435 \u0434\u043E\u043B\u0436\u0435\u043D \u0431\u044B\u0442\u044C \u043F\u043E\u0434\u043A\u043B\u044E\u0447\u0435\u043D \u043A \u043A\u043E\u043D\u0442\u0440\u043E\u043B\u043B\u0435\u0440\u0443 \u043A\u043E\u0442\u043B\u0430" }),
    ],
    [
        'water_control_zota',
        _jsx(PopupError, { text: "\u0422\u0435\u043C\u043F\u0435\u0440\u0430\u0442\u0443\u0440\u0430 \u0442\u0435\u043F\u043B\u043E\u043D\u043E\u0441\u0438\u0442\u0435\u043B\u044F \u0441\u0447\u0438\u0442\u044B\u0432\u0430\u0435\u0442\u0441\u044F \u0441 \u043A\u043E\u0442\u043B\u0430" }),
    ],
    ['air_zota', _jsx(AirZota, {})],
    ['outside_temperature', _jsx(OutsideTemperature, {})],
]);
export function HintDialog(props) {
    const { content_key, onClose } = props;
    return (_jsx(ErrorBoundary, { children: _jsx(MessageBox, { open: content_key !== null, onClose: onClose, isInfo: true, closeButtonTitle: "\u041E\u041A", maxWidth: "xs", children: _jsx(ErrorBoundary, { children: content_key && hint_dialog_content.get(content_key) }) }) }));
}
